import Pusher from "pusher-js"
import { pusher } from "config"
import { LOCAL_STORAGE_TAGS } from "constants/index"

const user = JSON.parse(localStorage.getItem(LOCAL_STORAGE_TAGS.AUTH_USER))

const pusherJS = new Pusher(pusher.key, {
  cluster: "mt1",
  enabledTransports: ["ws"],
})
Pusher.logToConsole = true

const channel = pusherJS.subscribe("mp2_notification_channel_user_" + user?.id)

export const bindEvent = (event_name, fn) => {
  channel.bind(event_name, data => fn(data))
}
